export const isKickReportTemplate = (template: { templateId: string | null }) =>
    template.templateId === null;
